export const TARGET_MARKETS = [
    '1x2',
    'asian_handicap',
    'totals',
    'half_1x2',
    'half_asian_handicap',
    'half_totals',
];
export const QUOTE_SIDES = ['home', 'draw', 'away', 'over', 'under'];
export const SOURCE_KINDS = [
    'odds_1x2',
    'odds_match',
    'odds_halfmatch',
    'william_movement',
    'ladbrokes_movement',
    'team_detail',
    'schedule_discovery',
    'live_scores',
    'match_analysis',
    'match_qingbao',
    'league_season',
    'lottery_schedule',
];
//# sourceMappingURL=types.js.map